import http from "@/http-common";

export default class CodeService {
	
	getCodeList(_params) {
		return http.get('/cm/code', { params: _params}).then(res => res.data);
	}

	getEnvCodeList(_params) {
		return http.get('/cm/code/env', { params: _params}).then(res => res.data);
	}

	getTableCodeList(_params) {
		return http.get('/cm/code/table', { params: _params}).then(res => res.data);
	}

	selectSqlCodeList(_params) {
		return http.get('/cm/code/sql', { params: _params}).then(res => res.data);
	}
	
	getmodChk(_params) {
		return http.get('/cm/code/modChk', { params: _params}).then(res => res.data);
	}
}